import { render } from "./Admin.Shop.EditProduct.vue?vue&type=template&id=a6a60ca8"
import script from "./Admin.Shop.EditProduct.vue?vue&type=script&lang=js"
export * from "./Admin.Shop.EditProduct.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__